if (!customElements.get('swiper-slider-tab')) {
  customElements.define(
    'swiper-slider-tab',
    class SwiperSliderTab extends SwiperSlider {
      swiperInstance = null;
      isSwiperInitialized = false;

      get swiperEl() {
        return this.querySelector(`#Swiper-${this.swiperId}`);
      }

      get swiperThumbEls() {
        return this.querySelectorAll(`[data-scroll-slide-button]`);
      }

      get swiperPagination() {
        return {
          el: this.swiperControlElements.pagination,
          type: "progressbar",
        };
      }

      constructor() {
        super();
        this.swiperSlideTo = this.swiperSlideToEvent.bind(this);
      }

      setupProps() {
        this.swiperOptions = {
          slidesPerView: this.defaultView.slides,
          spaceBetween: this.defaultView.space,
          pagination: this.swiperPagination,
          navigation: this.swiperNavigations,
          breakpoints: this.swiperBreakpoints,
          on: {
            init: () => this.debouncedResizeHeight(),
            slideChange: () => { this.updateActiveButton(this.swiperThumbEls[this.swiper.realIndex]) }
          },
        };
      }

      swiperSlideToEvent(event) {
        const scrollButtonTarget = event.target.closest('[data-scroll-slide-button]');
        if (!scrollButtonTarget) return;

        const slideToIndex = scrollButtonTarget.getAttribute('data-slide-index');
        this.swiper?.slideTo(slideToIndex);
        // this.updateActiveButton(scrollButtonTarget);

      }

      updateActiveButton(button) {
        button.classList.add('active');
        Array.from(this.swiperThumbEls).filter(item => item != button).forEach((button) => {
          if (button.classList.contains('active')) button.classList.remove('active');
        });

        const slideToIndexLast = button == this.swiperThumbEls[this.swiperThumbEls.length - 1];
        button.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: slideToIndexLast ? 'end' : 'center'
        });
      }

      initMutationObserver() {
        this.observer = new MutationObserver(() => {
          super.enableOrDisableSwiper();
          this.isSwiperInitialized = this.swiperEl && Boolean(this.swiperEl.classList.contains('swiper-initialized'));
          if (this.isSwiperInitialized) this.addEventListener('click', this.swiperSlideTo);
        });

        this.observer.observe(this, { attributes: true });
      }
    }
  )
}

if (!customElements.get('swiper-collection')) {
  customElements.define(
    'swiper-collection',
    class SwiperCollectionSlider extends SwiperSlider {
      swiperInstance = null;
      isSwiperInitialized = false;

      get swiperEl() {
        return this.querySelector(`#Swiper-${this.swiperId}`);
      }

      get swiperThumbEls() {
        return this.querySelectorAll(`[data-scroll-slide-button]`);
      }

      get swiperPagination() {
        return {
          el: this.swiperControlElements.pagination,
          // dynamicBullets: true,
          clickable: true,
        };
      }

      constructor() {
        super();
        this.swiperSlideTo = this.swiperSlideToEvent.bind(this);
      }

      setupProps() {
        this.swiperOptions = {
          slidesPerView: this.defaultView.slides,
          spaceBetween: this.defaultView.space,
          pagination: this.swiperPagination,
          navigation: this.swiperNavigations,
          breakpoints: this.swiperBreakpoints,
          on: {
            init: () => this.debouncedResizeHeight(),
          },
        };
      }

      swiperSlideToEvent(event) {
        const scrollButtonTarget = event.target.closest('[data-scroll-slide-button]');
        if (!scrollButtonTarget) return;

        const slideToIndex = scrollButtonTarget.getAttribute('data-slide-index');
        this.swiper?.slideTo(slideToIndex);
        // this.updateActiveButton(scrollButtonTarget);

      }

      initMutationObserver() {
        this.observer = new MutationObserver(() => {
          super.enableOrDisableSwiper();
          this.isSwiperInitialized = this.swiperEl && Boolean(this.swiperEl.classList.contains('swiper-initialized'));
          if (this.isSwiperInitialized) this.addEventListener('click', this.swiperSlideTo);
        });

        this.observer.observe(this, { attributes: true });
      }
    }
  )
}